import { API } from './interceptor'

export const notifyGoodsReceiptingPaywallSales = ({
  venueId,
  source = 'client',
  platform = 'dashboard',
  currentUsage = null,
  remainingLimit = null,
  purchaseOrderNumber = null,
  supplierTitle = null,
}) => {
  if (!venueId) {
    return Promise.resolve()
  }

  return API.post('api2', `venue/${venueId}/goods-receipting-paywall-notify`, {
    body: {
      source,
      platform,
      currentUsage,
      remainingLimit,
      purchaseOrderNumber,
      supplierTitle,
    },
  }).catch(() => {
    // Fire-and-forget; paywall UX must not depend on sales notify
  })
}
